import React from 'react'
import './upload-momentum-preview.styles.scss';
import { format } from 'date-fns';
import { properCase } from '@/utils/properCase';

const UploadMomentumPreview = ({ 
  gameElements,
  item, 
  removeItem }) => {

  return (
    <div className={`g-list-item upload-momentum-preview ${item.opt_momentumDirection}`}>
      <div className='preview-details'>
        <div className='title'>{item.name} | <span className='meta'>{properCase(item.opt_momentumDirection)}</span></div>

        {
          (item.desc) &&
          <div className='meta'>{item.desc}</div>
        }
        <div className='details'>
          {
            (item.opt_cat) &&
            <div className='meta'><b>Category:</b> {item.opt_cat}</div>
          }

          <div className='meta'><b>Visible:</b> {item.opt_visible ? 'True' : 'False'}</div>
          {
            (item.opt_dateOpen) &&
            <div className='meta'><b>Date Available:</b> {format(new Date(item.opt_dateOpen), 'Pp')}</div>
          }
          {
            (item.opt_dateClose) &&
            <div className='meta'><b>Date Closed:</b> {format(new Date(item.opt_dateClose), 'Pp')}</div>
          }
        </div>

        {
          (item.opt_momentumDirection === 'positive') &&
          <div className='rewards'>
            {
              (item.opt_earnedCurrency) &&
              <div className='meta'><b>Earned Currency:</b> {item.opt_earnedCurrency.toLocaleString()}</div>
            }
            {
              (item.opt_earnedItems && Object.values(item.opt_earnedItems).length > 0) &&
              <div className='meta'><b>Earned Items:</b> {Object.keys(item.opt_earnedItems)
                .map(key => {
                  let element = gameElements[key];
                  if (element && element.type === 'item' && item.opt_earnedItems[key]) {
                    let name = element ? element.name : key;
                    let qty = item.opt_earnedItems[key].quantity;
                    return `${name} (x${qty})`;
                  }
                  return null;
                }).filter(Boolean).join(', ')
              }</div>
            }
            {
              (item.opt_earnedPrizePacks && Object.values(item.opt_earnedPrizePacks).length > 0) &&
              <div className='meta'><b>Earned Prize Packs:</b> {Object.keys(item.opt_earnedPrizePacks)
              .map(
                key => {
                  let element = gameElements[key];
                  if (element && element.type === 'prizePack' && item.opt_earnedPrizePacks[key]) {
                    let name = element ? element.name : key;
                    let qty = item.opt_earnedPrizePacks[key].quantity;
                    return `${name} (x${qty})`
                  }
                  return null;
                }
                ).filter(Boolean).join(', ')
              }</div>
            }
          </div>
        }
        {
          (item.opt_momentumDirection === 'negative') &&
          <div className='loss'>
            {
              (item.opt_removeCurrency) &&
              <div className='meta'><b>Lost Currency:</b> {item.opt_removeCurrency.toLocaleString()}</div>
            }
            {
              (item.opt_removeItems && Object.keys(item.opt_removeItems).length > 0) &&
              <div className='meta'><b>Lost Items:</b> {Object.keys(item.opt_removeItems).map(key => {
                let element = gameElements[key];
                if (element && element.type === 'item' && item.opt_removeItems[key]) {
                  let name = element ? element.name : key;
                  let qty = item.opt_removeItems[key].quantity;
                  return `${name} (x${qty})`;
                }
                return null;
              }).filter(Boolean).join(', ')}</div>
            }
          </div>
        }
      </div>
      <div className='buttons'>
        <button
          className='g-button med-btn'
          onClick={() => removeItem(item)}
        >Remove</button>
      </div>
    </div>
  )
}

export default UploadMomentumPreview